import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { currency, fromDenom, numberPendek } from "utils/Helpers"
import { showSimpleModal } from "utils/Modals"

type Props = {
    amount: number,
    tokenInfo?: TokenInfoResponse,
    icon: string,
    color: string,
    label: string,
    onShowDetail?: () => void
}

export function AssetInfoCard({ amount, tokenInfo, icon, color, label, onShowDetail }: Props) {
    return <div className="card">
        <div className="card-body">
            <div className="card-title d-flex align-items-start justify-content-between">
                <div className="avatar flex-shrink-0">
                    <span className={`avatar-initial rounded bg-label-${color}`}><i className={`bx bx-${icon}`}></i></span>
                </div>
            </div>
            <span className="d-block mb-1">{label}</span>
            <h3 className="card-title text-nowrap mb-2">{numberPendek(amount)} {tokenInfo?.symbol}</h3>
            <button
                onClick={() => {
                    if (onShowDetail) onShowDetail()
                    else showSimpleModal(
                        label,
                        <div className="d-flex align-items-center gap-1">
                            <h6 className="mb-0">{currency(amount)}</h6>
                            <span className="text-muted">{tokenInfo?.symbol}</span>
                        </div>
                    )
                }}
                className="btn btn-sm mt-1 btn-outline-primary text-nowrap">
                Detailed
            </button>
        </div>
    </div>
}